import { render, staticRenderFns } from "./Turnstile.vue?vue&type=template&id=29c3159d&"
import script from "./Turnstile.vue?vue&type=script&lang=ts&"
export * from "./Turnstile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports